import { Component } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Navegação apenas entre relatórios específicos.
 * Não inclui o espelho financeiro (/financial/cashflow).
 */
@Component({
  selector: 'app-financial-reports-nav',
  template: `
    <nav class="financial-reports-nav nav nav-pills mb-4" aria-label="Relatórios com API dedicada">
      <a
        class="nav-link"
        [class.active]="isHubTab()"
        routerLink="/financial/reports">
        Todos os relatórios
      </a>
      <a
        class="nav-link"
        [class.active]="isApPositionTab()"
        routerLink="/financial/reports/ap-position">
        Posição contas a pagar
      </a>
    </nav>
  `,
  styles: [
    `
      .financial-reports-nav .nav-link {
        color: #374151;
        font-weight: 500;
      }
      .financial-reports-nav .nav-link.active {
        background: var(--primary-color, #2563eb);
        color: #fff;
      }
    `
  ]
})
export class FinancialReportsNavComponent {
  constructor(private router: Router) {}

  isHubTab(): boolean {
    const url = this.router.url.split('?')[0];
    return url === '/financial/reports';
  }

  isApPositionTab(): boolean {
    const url = this.router.url.split('?')[0];
    return url.startsWith('/financial/reports/ap-position');
  }
}
